var GridStateAccessModule_1;
import { __decorate, __metadata } from "tslib";
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabIdService } from './state/tab-id.service';
import { GridStateService } from './state/grid-state.service';
import { GridStateStore } from './state/grid-state.store';
import { GridStateQuery } from './state/grid-state.query';
import { GridStateAddToClearGuard } from './state/grid-state-add-to-clear.guard';
import { GridStateClearGuard } from './state/grid-state-clear.guard';
let GridStateAccessModule = GridStateAccessModule_1 = class GridStateAccessModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot() {
        return {
            ngModule: GridStateAccessModule_1,
            providers: [
                TabIdService,
                GridStateService,
                GridStateStore,
                GridStateQuery,
                GridStateAddToClearGuard,
                GridStateClearGuard,
            ],
        };
    }
};
GridStateAccessModule.ctorParameters = () => [
    { type: GridStateAccessModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
GridStateAccessModule = GridStateAccessModule_1 = __decorate([
    NgModule({
        imports: [CommonModule],
    }),
    __metadata("design:paramtypes", [GridStateAccessModule])
], GridStateAccessModule);
export { GridStateAccessModule };
